export const back_arrow = `
<svg fill="" height="800px" id="Layer_1" version="1.1" viewBox="0 0 512 512" width="800px"
\t xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
<g>
\t<g>
\t\t<path d="M437.02,74.982C388.667,26.628,324.38,0,256,0S123.333,26.628,74.98,74.982C26.628,123.333,0,187.619,0,256
\t\t\ts26.628,132.667,74.98,181.019C123.333,485.372,187.62,512,256,512s132.667-26.628,181.02-74.981
\t\t\tC485.372,388.667,512,324.381,512,256S485.372,123.333,437.02,74.982z M256,491.602c-129.911,0-235.602-105.69-235.602-235.602
\t\t\tS126.089,20.398,256,20.398S491.602,126.089,491.602,256S385.911,491.602,256,491.602z"/>
\t</g>
</g>
<g>
\t<g>
\t\t<path d="M450.365,178.795C428.7,124.297,384.824,81.139,329.987,60.387c-5.27-1.996-11.155,0.662-13.149,5.929
\t\t\tc-1.995,5.268,0.66,11.156,5.929,13.149c49.491,18.728,89.089,57.679,108.643,106.865c1.589,3.998,5.424,6.435,9.48,6.435
\t\t\tc1.253,0,2.528-0.234,3.766-0.724C449.89,189.959,452.447,184.03,450.365,178.795z"/>
\t</g>
</g>
<g>
\t<g>
\t\t<path d="M291.371,49.898c-11.606-1.979-23.505-2.981-35.371-2.981c-5.633,0-10.199,4.567-10.199,10.199S250.367,67.315,256,67.315
\t\t\tc10.72,0,21.467,0.906,31.943,2.69c0.58,0.1,1.157,0.148,1.726,0.148c4.88,0,9.195-3.515,10.043-8.488
\t\t\tC300.657,56.112,296.923,50.844,291.371,49.898z"/>
\t</g>
</g>
<g>
\t<g>
\t\t<path d="M227.57,258.732l77.61-77.61c5.596-5.595,8.677-13.036,8.677-20.948c0-7.914-3.082-15.354-8.677-20.948
\t\t\tc-5.595-5.596-13.035-8.677-20.948-8.677s-15.354,3.082-20.949,8.677l-98.558,98.558c-11.551,11.552-11.551,30.346,0,41.897
\t\t\tl98.559,98.558c5.596,5.596,13.036,8.677,20.948,8.677s15.351-3.081,20.948-8.677c5.596-5.595,8.677-13.036,8.677-20.948
\t\t\tc0-7.914-3.082-15.354-8.677-20.948L227.57,258.732z M290.755,363.816c-1.743,1.743-4.06,2.703-6.524,2.703
\t\t\tc-2.464,0-4.781-0.96-6.524-2.703l-98.558-98.558c-3.597-3.597-3.597-9.452,0-13.049l98.559-98.558
\t\t\tc1.743-1.743,4.059-2.703,6.524-2.703s4.781,0.96,6.522,2.705c1.743,1.742,2.703,4.058,2.703,6.523c0,2.464-0.96,4.78-2.703,6.523
\t\t\tl-84.822,84.822c-3.983,3.984-3.983,10.442,0,14.425l84.823,84.823c1.743,1.742,2.703,4.059,2.703,6.523
\t\t\tS292.497,362.073,290.755,363.816z"/>
\t</g>
</g>
</svg>`;

